import React, { useState } from "react";
import "./ParticipantProfilePictureUpload.css";
import handleAccountProfilePictureUpload from "./handlePictureUpload";

interface ParticipantProfilePictureUploadProps {
  selectedAccountProfileIdInt: number;
  setProfilePictureUrl: (url: string | null) => void;
}

const ParticipantProfilePictureUpload: React.FC<
  ParticipantProfilePictureUploadProps
> = ({
  selectedAccountProfileIdInt: selectedFundraiserRoleIdInt,
  setProfilePictureUrl,
}) => {
  const [formError, setFormError] = useState<string>("");

  return (
    <div className="participant-join-form-file-upload-container">
      <label className="participant-join-form-file-upload">
        <input
          type="file"
          onChange={(event) =>
            handleAccountProfilePictureUpload(
              event,
              setProfilePictureUrl,
              setFormError,
              selectedFundraiserRoleIdInt
            )
          }
          disabled={selectedFundraiserRoleIdInt === 0}
        />
        Choose Profile Picture
      </label>
      {formError && <p className="error-message">{formError}</p>}
    </div>
  );
};

export default ParticipantProfilePictureUpload;
